/**
 * 组件库入口文件
 */

import Scrollbar from '@/components/scrollbar';
import Button from '@/components/button';
import ButtonGroup from '@/components/button-group';
import Icon from '@/components/icon';
import Link from '@/components/link';
import Radio from '@/components/radio';
import RadioButton from '@/components/radio-button';
import RadioGroup from '@/components/radio-group';
import Input from '@/components/input';
import InputNumber from '@/components/input-number';
import Autocomplete from '@/components/autocomplete';
import Checkbox from '@/components/checkbox';
import CheckboxButton from '@/components/checkbox-button';
import CheckboxGroup from '@/components/checkbox-group';
import Select from '@/components/select';
import Cascader from '@/components/cascader';
import CascaderPanel from '@/components/cascader-panel';
import Option from '@/components/option';
import OptionGroup from '@/components/option-group';
import SelectPage from '@/components/select-page';
import Switch from '@/components/switch';
import Slider from '@/components/slider';
import Rate from '@/components/rate';
import DatePicker from '@/components/date-picker';
import TimePicker from '@/components/time-picker';
import TimeSelect from '@/components/time-select';
import ColorPicker from '@/components/color-picker';
import Upload from '@/components/upload';
import Transfer from '@/components/transfer';
import Form from '@/components/form';
import FormItem from '@/components/form-item';
import Table from '@/components/table';
import TableColumn from '@/components/table-column';
import Tag from '@/components/tag';
import Progress from '@/components/progress';
import Tree from '@/components/tree';
import Pagination from '@/components/pagination';
import Badge from '@/components/badge';
import Dropdown from '@/components/dropdown';
import DropdownItem from '@/components/dropdown-item';
import Step from '@/components/step';	
import Steps from '@/components/steps';	
import DropdownMenu from '@/components/dropdown-menu';
import Avatar from '@/components/avatar';
import Tooltip from '@/components/tooltip';
import Popover from '@/components/popover';
import Dialog from '@/components/dialog';
import Alert from '@/components/alert';
import MessageBox from '@/components/message-box';
import Notification from '@/components/notification';
import Menu from '@/components/menu';
import MenuItem from '@/components/menu-item';
import MenuItemGroup from '@/components/menu-item-group';
import Submenu from '@/components/submenu';
import Tabs from '@/components/tabs';
import TabPane from '@/components/tab-pane';
import Message from '@/components/message';
import Loading from '@/components/loading';	
import Backtop from '@/components/backtop';	
import Row from '@/components/row';	
import Col from '@/components/col';	
import Aside from '@/components/aside';	
import Main from '@/components/main';	
import Header from '@/components/header';	
import Container from '@/components/container';	
import Footer from '@/components/footer';	
import Collapse from '@/components/collapse';	
import CollapseItem from '@/components/collapse-item';	
import CollapseTransition from '@/components/collapse-transition';
import Carousel from '@/components/carousel';	
import CarouselItem from '@/components/carousel-item';	
import Drawer from '@/components/drawer';	
import Image from '@/components/image';	
import Calendar from '@/components/calendar';
import Timeline from '@/components/timeline';
import TimelineItem from '@/components/timeline/src/item';
import Breadcrumb from '@/components/breadcrumb';
import BreadcrumbItem from '@/components/breadcrumb-item';
import Card from '@/components/card';
import Divider from '@/components/divider';
import WordVerify from '@/components/word-verify';
import SliderVerify from '@/components/slider-verify';

import { Base64 } from 'js-base64';
import md5 from 'js-md5';

import tools from '@/tools';

import ClickOutside from '@/directives/clickoutside';

const components = {
	Scrollbar,
    Button,
	ButtonGroup,
	Icon,
	Link,
	Radio,
	RadioButton,
	RadioGroup,
	Input,
	InputNumber,
	Autocomplete,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Select,
	Cascader,
	CascaderPanel,
	Option,
	OptionGroup,
	SelectPage,
	Switch,
	Slider,
	Rate,
	DatePicker,
	TimePicker,
	TimeSelect,
	ColorPicker,
	Upload,
	Transfer,
	Form,
	FormItem,
	Table,
	TableColumn,
	Tag,
	Progress,
	Tree,
	Pagination,
	Badge,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	Step,
	Steps,
	Avatar,
	Tooltip,
	Popover,
	Dialog,
	Alert,
	MessageBox,
	Notification,
	Menu,
	MenuItem,
	MenuItemGroup,
	Submenu,
	Tabs,
	TabPane,
	Message,
	Backtop,
	Row,
	Col,
	Aside,
	Main,
	Header,
	Container,
	Footer,
	Collapse,
	CollapseItem,
	CollapseTransition,
	Carousel,
	CarouselItem,
	Drawer,
	Image,
	Calendar,
	Timeline,
	TimelineItem,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	Divider,
	WordVerify,
	SliderVerify,
};


//注册组件库的具体内容
const install = function(Vue, opts = {}) {
    if (install.installed) {return;}
    
    //注册组件
    Object.keys(components).forEach(key => {
        Vue.component(components[key].name, components[key]);
    });
    
	// 注册指令
	Vue.use(Loading.directive);
	Vue.directive('clickoutside', ClickOutside);
	
	// 组件全局参数
	Vue.prototype.$YJ = {
	    size: opts.size || '',
	    zIndex: opts.zIndex || 3000
	};
	
	// 注册全局属性
	Vue.prototype.$loading = Loading.service;
	Vue.prototype.$msgbox = MessageBox;
	Vue.prototype.$alert = MessageBox.alert;
	Vue.prototype.$confirm = MessageBox.confirm;
	Vue.prototype.$prompt = MessageBox.prompt;
	Vue.prototype.$notify = Notification;
	Vue.prototype.$message = Message;
	
    //自动注册工具类
    Vue.prototype.$tools = tools;
	Vue.prototype.$base64 = Base64;
	Vue.prototype.$md5 = md5;
	
};

// 解决md5及工具类在组件库用script引入不挂载的问题
if(typeof window !== 'undefined'){
	window.md5 = md5;
	window.tools = tools;
}

// 自动注册
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

//对外暴露的api
const API = {
    version: process.env.VERSION,
    install,
    tools: tools,
	Base64: Base64,
	md5: md5,
    ...components
};

module.exports.default = module.exports = API;



// WEBPACK FOOTER //
// ./src/index.js